<template>
    <div class="slideshow">
        <div class="slide d-flex align-items-center">
            <div v-show="active > 0" class="nav pre" @click="pre">
                <a-icon type="left" />
            </div>
            <background-image
                class="photo-area"
                mode="contain"
                icon-size="20px"
                :src="current.img | compressSmall"
            />
            <div v-show="active < totalPage - 1" class="nav next" @click="next">
                <a-icon type="right" />
            </div>
        </div>
        <div class="info d-flex align-items-center justify-content-center my-4">
            <div class="page-info d-flex mb-1">
                <div class="current text-primary">{{ active + 1 }}</div>
                <div class="page-break"></div>
                <!-- <div class="page-break-letter">/</div> -->
                <div class="total">{{ totalPage }}</div>
            </div>

            <template v-show="current.title || current.content">
                <div class="line mx-5"></div>

                <div class="flex-fill">
                    <div v-show="current.title" class="title">
                        {{ current.title }}
                    </div>
                    <div v-show="current.content" class="content">
                        {{ current.content }}
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: Number,
        list: Array
    },
    computed: {
        current() {
            return this.list[this.active]
        },
        totalPage() {
            return this.list.length
        }
    },
    methods: {
        pre() {
            this.change(this.active - 1)
        },
        next() {
            this.change(this.active + 1)
        },
        change(val) {
            this.$emit("update:active", val)
        }
    }
}
</script>


<style lang="scss" scoped>
.slide {
    border: 1px solid var(--border-color);
    height: 500px;
    user-select: none;
}

.nav {
    background: #c7c8c9;
    margin: 0 2px;
    height: 80px;
    width: 40px;
    color: #fff;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;

    transition: 0.3s;

    &:hover {
        background: #bbb;
    }
}

.photo-area {
    flex: 1;
    align-self: stretch;
    margin: 15px 0;
}

.line {
    height: 40px;
    width: 2px;
    background: #dedfe0;
    border-radius: 1px;
}

.info {
    color: #848687;
}

.page-info {
    font-size: 24px;
    align-items: baseline;

    .current {
        font-size: 44px;
        vertical-align: bottom;
    }

    .page-break-letter {
        font-size: 18px;
        margin: 0 1ex 0;
    }

    .total,
    .page-break-letter {
        line-height: 24px;
    }

    .page-break {
        width: 2px;
        height: 16px;
        background: #848687;
        margin: 0 8px 0 6px;
        transform: rotate(22deg);
    }
}

.title {
    font-size: 20px;
    color: #333;
}
</style>